<template>
    <small class="has_error" :class="className" v-for="(err, index) in errors" :key="key(index)">{{ err }}</small>
</template>

<script>
export default {
    props: ['errors', 'className'],
    methods: {
        key(index) {
            return `validation_error_${index}_${Math.random()}`
        }
    }
}
</script>